<template>
    <div id="app">
      <router-view/>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App'
  }
  </script>
  
  <style>
  body, html, #app {
    margin: 0;
    padding: 0;
    height: 100%;
  }
  </style>
  